import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { SortHelper } from './sort-helper.util';
import { SorterClassesPipe } from './sorter-classes/sorter-classes.pipe';

@Component({
  selector: 'web-components-sorter-label',
  templateUrl: './sorter-label.component.html',
  imports: [CommonModule, TranslocoPipe, SorterClassesPipe],
})
export class SorterLabelComponent {
  @Input() public sorter?: SortHelper;
  @Input() public attr = '';
  @Input() public label = '';
  @Input() public direction: 'before' | 'after' = 'before';
}
